import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { CopyToClipboard } from "react-copy-to-clipboard";
import {
  openAddReviewer,
  publishProposal,
  fetchProposal,
  manageProposalModal,
  fetchProposalStep,
  editProposal,
} from "ProposalAction";
import { showError, showSuccess } from "ReduxErrorBar";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { COMMON_FAIL_MESSAGE, DOMAIN_NAME } from "Constants";
import LocaleStrings from "Languages";

class ProposalListItem extends Component {
  constructor(props) {
    super(props);
    this.state = { copied: false, loading: false };
  }

  copyUrl = () => {
    this.setState({ copied: true });

    setTimeout(() => {
      this.setState({ copied: false });
    }, 500);
  };

  addReviewer = () => {
    let { proposal } = this.props;
    //console.log('form',form);
    this.props.openAddReviewer(true, proposal.proposalid);
  };

  publishUnpublish = (e, mode) => {
    let { proposal } = this.props;

    if (mode == "not set") {
      this.props.showError("To publish please complete the abstract info");
    } else {
      this.setState({ loading: true });
      let values = {};
      values.ispublished = proposal.ispublished ? 0 : 1;
      values.proposalid = proposal.proposalid;
      this.props.publishProposal(this.props.session, values, (feedback) => {
        // console.log("proposal response", feedback);

        if (feedback.success === 0) {
          this.setState({ loading: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        } else {
          this.props.fetchProposal(this.props.session, (callback) => {});
          this.setState({ loading: false });
          if (values.ispublished) {
            this.props.showSuccess(
              LocaleStrings.proposal_form_published_successfully
            );
          } else {
            this.props.showSuccess(
              LocaleStrings.proposal_form_unpublished_successfully
            );
          }
        }
      });
    }
  };

  manageProposal = () => {
    let { proposal } = this.props;
    this.props.editProposal(proposal);
    this.props.manageProposalModal(true, proposal);
    this.props.fetchProposalStep("step_1");
  };

  render() {
    let { eventDetails, proposal } = this.props;
    //console.log('eventDetails',eventDetails);
    //console.log('proposal',proposal);
    var dragUrl = "../../style/images/drag_sign.png";
    let formnumber =
      proposal &&
      proposal.event_forms_by_formid &&
      proposal.event_forms_by_formid.formnumber
        ? proposal.event_forms_by_formid.formnumber
        : "";
    let seocode =
      eventDetails && eventDetails.seocode
        ? eventDetails.seocode
        : "not-found-seocode";
    var proposalUrl = `https://${seocode}.${DOMAIN_NAME}/t/proposals/${proposal.proposalid}`;

    let application_startdate = proposal.application_startdate
      ? moment(proposal.application_startdate, "YYYY-MM-DD")
      : null;
    let application_enddate = proposal.application_enddate
      ? moment(proposal.application_enddate, "YYYY-MM-DD")
      : null;
    let currentDate = moment();

    let isscheduled = "Not Yet Set";
    let mode = "not set";
    if (application_startdate && application_startdate) {
      if (
        currentDate.isAfter(moment(application_startdate)) &&
        currentDate.isBefore(moment(application_enddate))
      ) {
        isscheduled =
          "Live from " +
          moment(application_startdate).format("DD-MM-YYYY") +
          " To " +
          moment(application_enddate).format("DD-MM-YYYY");
        mode = "live";
      } else if (currentDate.isBefore(moment(application_startdate))) {
        isscheduled =
          "Will be Scheduled  from " +
          moment(application_startdate).format("DD-MM-YYYY");
        mode = "soon";
      } else if (currentDate.isAfter(moment(application_enddate))) {
        isscheduled =
          "Expired on " + moment(application_enddate).format("DD-MM-YYYY");
        mode = "expired";
      }
    }

    return (
      <tr
        style={
          mode == "live"
            ? { backgroundColor: "#e6f0ff" }
            : mode == "expired"
            ? { backgroundColor: "#fedddd69" }
            : mode == "soon"
            ? { backgroundColor: "#fbffc269" }
            : {}
        }
      >
        <td className="first-td">
          {proposal.proposal_name}
          {mode == "not set" ? (
            <OverlayTrigger
              key={proposal.proposalid}
              placement="bottom"
              overlay={
                <Tooltip id={`tooltip-${proposal.proposalid}`}>
                  <span>
                    the abstract is not published yet, To publish please
                    complete the abstract info
                  </span>
                </Tooltip>
              }
            >
              <span
                className="glyphicon glyphicon-warning-sign"
                style={{ color: "#f30909", paddingLeft: 10 }}
              ></span>
            </OverlayTrigger>
          ) : mode == "soon" ? (
            <OverlayTrigger
              key={proposal.proposalid}
              placement="bottom"
              overlay={
                <Tooltip id={`tooltip-${proposal.proposalid}`}>
                  The abstract will be Scheduled.
                </Tooltip>
              }
            >
              <span
                className="glyphicon glyphicon-info-sign"
                style={{ color: "#ff0000", paddingLeft: 10 }}
              ></span>
            </OverlayTrigger>
          ) : mode == "live" ? (
            <span
              className="badge badge-warning"
              style={{
                paddingLeft: 5,
                backgroundColor: "#5cb85c",
                color: "#fff",
                borderColor: "#4cae4c",
                marginLeft:'10px'
              }}
            >
              Live
            </span>
          ) : (
            ""
          )}
        </td>
        <td className="middle-td">{proposal.category}</td>
        <td className="middle-td">{isscheduled}</td>
        <td className="middle-td">
          {proposal.proposal_response_by_proposalidfk
            ? proposal.proposal_response_by_proposalidfk.length
            : 0}
        </td>

        <td className="last-td" style={{ width: 426 }}>
          <div className="action-button" style={{ marginLeft: 5 }}>
            {this.state.copied ? (
              <div className="">
                <button className="btn btn-custom-table-white">
                  {LocaleStrings.button_copied}
                </button>
              </div>
            ) : (
              <CopyToClipboard text={proposalUrl} onCopy={this.copyUrl}>
                <div className="">
                  <button className="btn btn-custom-table-white">
                    {LocaleStrings.button_copy_url}
                  </button>
                </div>
              </CopyToClipboard>
            )}
          </div>
          <div className="action-button" style={{ marginLeft: 5 }}>
            <button
              className="btn btn-custom-table-white"
              onClick={this.manageProposal}
            >
              {LocaleStrings.manage_proposal}
            </button>
          </div>

          {/* <div className="action-button" style={{marginLeft: 5}}>
            <button className="btn btn-custom-table-white" onClick={this.addReviewer} >{LocaleStrings.dashboard_button_add_reviewer}</button>
           
          </div> */}
          <div className="action-button" style={{ marginLeft: 15 }}>
            {/* <button className="btn btn-custom-table-white" onClick={this.publishUnpublish}>{proposal.ispublished ? this.state.loading ? 'Please wait' : LocaleStrings.dashboard_button_unpublish : this.state.loading ? 'Please wait' : LocaleStrings.dashboard_button_publish}</button> */}

            <OverlayTrigger
              key={proposal.proposalid}
              placement="top"
              overlay={
                <Tooltip id={`tooltip-${proposal.proposalid}`}>
                  <span>{proposal.ispublished ? "Unpublish" : "Publish"}</span>
                </Tooltip>
              }
            >
              <label className="template-live-switch">
                <input
                  type="checkbox"
                  onChange={(e) => this.publishUnpublish(e, mode)}
                  checked={proposal.ispublished ? true : false}
                />
                <span className="template-live-slider template-live-round"></span>
              </label>
            </OverlayTrigger>
          </div>
        </td>
      </tr>
    );
  }
}

export var mapStateToProps = (state) => {
  return {
    session: state.session,
    eventDetails: state.userEventDetails,
  };
};

export default connect(mapStateToProps, {
  openAddReviewer,
  publishProposal,
  showError,
  showSuccess,
  fetchProposal,
  manageProposalModal,
  fetchProposalStep,
  editProposal,
})(ProposalListItem);
